import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type { DeliverySettingsResponse, ResponseData, SettingsSaveRequest } from "../../../../graphql/types"

export const fetchDeliverySettings = (
    headers: Record<string, any>,
    locationId: string,
    terminalId: string
): Promise<Maybe<DeliverySettingsResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query settings($locationId: String, $terminalId: String) {
                    settings(locationId: $locationId, terminalId: $terminalId) {
                        delivery {
                            deliveryFeeConfig {
                                deliveryFeeEnabled
                                baseDeliveryFee
                                freeDelivery
                                distanceFeeEnabled
                                distanceFeeValues {
                                    distance
                                    fee
                                }
                            }
                            deliveryAreaConfig {
                                type
                                deliveryDistance
                                deliveryZipCodes
                                deliveryMapAreas {
                                    id
                                    fee
                                    minOrderAmount
                                    coords {
                                        lat
                                        lng
                                    }
                                }
                            }
                            deliveryPartners {
                                pickupDelay
                                pickupInstructions
                                phoneContactForDelivery
                                doordashEnabled
                                doordashAllowedVehicles
                                relayEnabled
                                relayProducerKey
                                relayApiKey
                                ondyEnabled
                                onfleetEnabled
                                onfleetApiKey
                                onfleetWebhookSecret
                                shipdayEnabled
                                shipdayApiKey
                                shipdayWebhookSecret
                                ateamEnabled
                                uberEnabled
                                uberDirectOrganizationId
                                selfDeliveryEnabled
                            }
                        }
                    }    
                }
            `,
            operationName: "settings",
            variables: {
                locationId: locationId,
                terminalId: terminalId,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.settings && response.data.settings.delivery) {
            return response.data.settings.delivery
        }

        return null
    })

export const saveSettingsMutation = (headers: Record<string, any>, data: SettingsSaveRequest): Promise<ResponseData> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation settingsSave($data: SettingsSaveRequest!) {
                    settingsSave(data: $data) {
                        success
                    }
                }
            `,
            operationName: "settingsSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.settingsSave
    })
